import { render, staticRenderFns } from "./cooperationInfo.vue?vue&type=template&id=50ee2494&scoped=true&"
import script from "./cooperationInfo.vue?vue&type=script&lang=js&"
export * from "./cooperationInfo.vue?vue&type=script&lang=js&"
import style0 from "./cooperationInfo.vue?vue&type=style&index=0&id=50ee2494&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee2494",
  null
  
)

export default component.exports